var StateCollection = function(){
    var states = [];
    this.getStates = function(){
        return states;
    };
    this.state = function(name, params){
        states.push(angular.extend({name: name}, params));
        return this;
    };
};

var ci_states = new StateCollection();